import { Button } from 'antd';
import React from 'react';
import { ClipLoader } from 'react-spinners';

const NormalFlowGoLiveButton = ({
  showLoader,
  unit,
  t,
  goLiveDisabled,
  handleStartStream,
  isLanguageRuOrFr,
  openStopStreamModal,
}) => {
  const isStreaming = unit.status === 'streaming';
  const loading = showLoader[unit.BOSSID];

  const button = (
    <Button
      type='button'
      className={[
        'btn',
        isStreaming ? 'btn-danger' : 'btn-primary',
        isLanguageRuOrFr ? 'ru-ant-btn' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      size='large'
      title={loading ? undefined : isStreaming ? t('STOPUNIT') : t('STARTUNIT')}
      disabled={loading || (!isStreaming && goLiveDisabled)}
      onClick={
        loading
          ? undefined
          : () => {
              if (isStreaming) {
                openStopStreamModal();
              } else {
                handleStartStream();
              }
            }
      }
      style={{
        color: '#fff',
        backgroundColor: isStreaming ? '#dc3545' : '',
      }}
    >
      {loading ? (
        <span>
          <ClipLoader size={22} color='#ffffff' loading={loading} />
        </span>
      ) : (
        t(isStreaming ? 'STOP' : 'GOLIVE')
      )}
    </Button>
  );

  return button;
};

export default NormalFlowGoLiveButton;
